import { createRouter, createWebHashHistory } from 'vue-router'

// 路由配置数组
const routes = [
    // 默认重定向到登录页
    {
        path: '/',
        redirect: '/login'
    },
    // 登录页（无需权限）
    {
        path: '/login',
        name: 'LoginPage',
        component: () => import('../views/LoginPage.vue'),
        meta: { requiresAuth: false }
    },

    // 首页（需登录权限）
    {
        path: '/home',
        name: 'HomePage',
        component: () => import('../views/home/HomePage.vue'),
        meta: { requiresAuth: true },
        redirect: "/index",
        children: [
            {
                path: '/index',
                name: 'IndexPage',
                component: () => import('../views/home/IndexPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/dashboard',
                name: 'DashboardPage',
                component: () => import('../views/DashboardPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/school',
                name: 'SchoolPage',
                component: () => import('../views/school/SchoolPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/school/list',
                redirect: '/school'
            },
            {
                path: '/user',
                name: 'UserPage',
                component: () => import('../views/user/UserPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/user/list',
                redirect: '/user'
            },
            {
                path: '/book',
                name: 'BookPage',
                component: () => import('../views/book/BookPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/book/list',
                redirect: '/book'
            },
            {
                path: '/major',
                name: 'MajorPage',
                component: () => import('../views/major/MajorPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/major/list',
                redirect: '/major'
            },
            {
                path: '/campus',
                name: 'CampusPage',
                component: () => import('../views/campus/CampusPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/campus/list',
                redirect: '/campus'
            },
            {
                path: '/order',
                name: 'OrderPage',
                component: () => import('../views/order/OrderPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/order/list',
                redirect: '/order'
            },
            {
                path: '/distribution',
                name: 'DistributionPage',
                component: () => import('../views/distribution/DistributionPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/distribution/list',
                redirect: '/distribution'
            },
            {
                path: '/aftersale',
                name: 'AftersalePage',
                component: () => import('../views/aftersale/AftersalePage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/aftersale/list',
                redirect: '/aftersale'
            },
            {
                path: '/supplier',
                name: 'SupplierPage',
                component: () => import('../views/supplier/SupplierPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/supplier/list',
                redirect: '/supplier'
            },
            {
                path: '/supplier/account',
                name: 'SupplierAccountPage',
                component: () => import('../views/supplier/SupplierAccountPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/settlement',
                name: 'SettlementPage',
                component: () => import('../views/settlement/SettlementPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/settlement/list',
                redirect: '/settlement'
            },
            {
                path: '/privacy',
                name: 'PrivacyPage',
                component: () => import('../views/privacy/PrivacyPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/privacy/list',
                redirect: '/privacy'
            },
            {
                path: '/account',
                name: 'AccountPage',
                component: () => import('../views/account/AccountPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/account/list',
                redirect: '/account'
            },
            {
                path: '/role',
                name: 'RolePage',
                component: () => import('../views/role/RolePage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/role/list',
                redirect: '/role'
            },
            {
                path: '/auth',
                name: 'MenuPage',
                component: () => import('../views/menu/MenuPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/auth/list',
                redirect: '/auth'
            },
            {
                path: '/stock',
                name: 'StockPage',
                component: () => import('../views/stock/StockPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/stock/list',
                redirect: '/stock'
            },
            {
                path: '/log',
                name: 'LogPage',
                component: () => import('../views/log/LogPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/log/list',
                redirect: '/log'
            },
            {
                path: '/feedback',
                name: 'FeedbackPage',
                component: () => import('../views/feedback/FeedbackPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/feedback/list',
                redirect: '/feedback'
            },
            {
                path: '/category',
                name: 'CategoryPage',
                component: () => import('../views/category/CategoryPage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/category/list',
                redirect: '/category'
            },
            // 系统管理模块
            {
                path: '/system',
                name: 'SystemPage',
                component: () => import('../views/system/SystemPage.vue'),
                meta: { requiresAuth: true }
            },
            // 系统管理子菜单路由
            {
                path: '/system/account',
                redirect: '/account'
            },
            {
                path: '/system/role',
                redirect: '/role'
            },
            {
                path: '/system/auth',
                redirect: '/auth'
            },
            // 系统配置
            {
                path: '/system/config',
                name: 'ConfigPage',
                component: () => import('../views/config/ConfigPage.vue'),
                meta: { requiresAuth: true }
            }
        ]
    },
    // 404页面
    {
        path: '/:pathMatch(.*)*',
        name: 'ErrorPage',
        component: () => import('../views/ErrorPage.vue'),
        meta: { requiresAuth: false }
    }
]

// 创建路由实例
const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

// 全局路由守卫（权限控制）
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token') || ''
    
    // 无需权限的页面直接放行
    if (!to.meta.requiresAuth) {
        return next()
    }

    // 需要权限的页面：有token放行，无token跳回登录页
    if (token) {
        next()
    } else {
        localStorage.clear()
        next('/login')
    }
})

export default router
